import axios from 'axios';

const LatestNews = {
	getNews: async () => {
		return await axios({
			method: 'GET',
			url: 'https://constellationmutual.com/wp-json/wp/v2/posts?categories=2',
		});
	},
};

export default LatestNews;
